import api from './api';
import type {
  SubscriptionPlan,
  SubscriptionStatus,
  InviteCode,
  RedeemResponse,
  AdminInviteCodeCreateRequest,
} from '@/types/subscription.types';

// ── 用户端 ──────────────────────────────────────────────────────────────────

export const getSubscriptionPlans = async (): Promise<SubscriptionPlan[]> => {
  const res = await api.get('/subscription/plans/');
  return res.data.results || res.data.data || [];
};

export const getSubscriptionStatus = async (): Promise<SubscriptionStatus | null> => {
  const res = await api.get('/subscription/status/');
  return res.data.data;
};

export const redeemInviteCode = async (code: string): Promise<RedeemResponse> => {
  const res = await api.post('/subscription/redeem/', { code });
  return res.data;
};

// ── Admin 端 ────────────────────────────────────────────────────────────────

export const getAdminInviteCodes = async (params?: { isUsed?: boolean; planId?: number; keyword?: string }): Promise<InviteCode[]> => {
  const res = await api.get('/subscription/admin/invite-codes/', { params });
  return res.data.results || res.data.data || [];
};

export const createAdminInviteCodes = async (data: AdminInviteCodeCreateRequest) => {
  const res = await api.post('/subscription/admin/invite-codes/create/', data);
  return res.data;
};

export const getAdminPlans = async (): Promise<SubscriptionPlan[]> => {
  const res = await api.get('/subscription/admin/plans/');
  return res.data.results || res.data.data || [];
};

export const createAdminPlan = async (data: Partial<SubscriptionPlan>) => {
  const res = await api.post('/subscription/admin/plans/', data);
  return res.data;
};

export const deleteAdminPlan = async (id: number) => {
  const res = await api.delete(`/subscription/admin/plans/${id}/`);
  return res.data;
};

export const revokeAdminInviteCode = async (id: number) => {
  const res = await api.post(`/subscription/admin/invite-codes/${id}/revoke/`);
  return res.data;
};
